import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/tr';
export const locale = {
  lang: 'tr',
  data: {
    'VOICE': {
      'ENABLE': 'Anket için ses parçalarını etkinleştirin',
      'TITULO': 'Ses ayarları',
      'SUBTITULO': 'Bu ayar, yalnızca ankete giden ses parçaları etkinleştirilirse uygulanacaktır.',
      'CONFIG_IDIOMA': {
        'TITULO': 'Bu dil için geçerli ayarlar',
        'GENERO': {
          'TITULO': 'ses cinsiyeti',
          'Femenino': 'Dişi',
          'Masculino': 'Erkek'
        },
        'TIPO_VOZ': {
          'TITULO': 'ses türü',
          '1': 'Ses türü 1',
          '2': 'Ses türü 2',
          '3': 'Ses türü 3',
          '4': 'Ses türü 4',
          '5': 'Ses türü 5',
          '6': 'Ses tipi 6',
          '7': 'Ses türü 7',
          '8': 'Ses türü 8',
          '9': 'Ses türü 9',
          '10': 'Ses türü 10',
        },
        'PRUEBA_VOZ': {
          'TITULO': 'Ses testi',
          'INSTRUCCION': 'Sesi test etmek için bir metin yazın',
          'PLACEHOLDER': 'Ses testi metni',
          'PROBAR': 'Metni konuşmaya test edin'
        }
      },
      'MODALES': {
        'COMPLETAR': 'Geçerli ses seçimiyle adımı tamamladığınızdan emin misiniz?',
        'COMPLETAR_OFF': 'Adımı ses ayarları devre dışıyken tamamlamak istediğinizden emin misiniz?',
        'INCOMPLETO': 'Henüz tüm dillerde tam ses seçimini yapmadınız, devam etmek için tamamlamanız gerekiyor',
        'PASO_COMPLETO': 'Adım başarıyla tamamlandı',
        'GENERANDO_AUDIOS': 'Bu ürünün bölümlerine ses ayarları uygulanıyor, lütfen biraz bekleyin'
      }
    }
  }
};
